import { Typography } from "@mui/material";
import React, { Fragment } from "react";

import TransactionValue from "./TransactionValue";

const Transaction = ({ transactions }) => {
  return (
    <>
      {transactions.map((transaction, index) => {
        return (
          <Fragment key={index}>
            <Typography
              style={{
                margin: "24px 0 8px 16px",
                color: "#043964",
                fontWeight: "bold",
                fontSize: "16px"
              }}
            >
              {transaction.month}
            </Typography>
            {transaction.data.map((trx, index) => {
              return (
                <div
                  key={index}
                  style={{
                    marginBottom: index !== trx.length - 1 ? "2px" : 0
                  }}
                >
                  <TransactionValue
                    date={trx.submittedDate}
                    transactionType={trx.type}
                    amount={
                      trx?.plan?.planId === "P11" || trx.actualAmt === null
                        ? trx.amount
                        : Number(trx.actualAmt)
                    }
                    fee={trx.feeAmount}
                  />
                </div>
              );
            })}
          </Fragment>
        );
      })}
    </>
  );
};

export default (Transaction);
